import { useMutation } from '@apollo/client';
import { useApiResponse } from '@libs/hooks';
import { requestExchangeNewMutation } from 'src/gql';

export const useRequestExchange = (onSuccess?: () => void) => {
  const [requestExchange, requestExchangeRes] = useMutation(
    requestExchangeNewMutation
  );
  const {
    loading: preReqLoading,
    response,
    errorMessage,
    clearErrorMessage,
  } = useApiResponse(requestExchangeRes, onSuccess);
  return {
    requestExchange,
    exchangeData: response?.requestExchangeNew,
    preReqLoading,
    errorMessage,
    error: requestExchangeRes.error,
    clearErrorMessage,
  };
};
